import React, { Component } from 'react'
import '../css/BisharatMain.css'
import { GiPartyPopper , GiPineTree , GiChurch , GiPublicSpeaker} from "react-icons/gi";
import { AiOutlineNotification } from "react-icons/ai";
import { BiPhotoAlbum } from "react-icons/bi";
import sectionImg from '../data/images/infosection.jpg';
import elikaMain from '../data/images/backmainelika.jpg';
import AuthService from '../services/AuthService';

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import translate from '../languages/translate';


export default class Home extends Component {

  // related to Login Forum -- Start
  constructor(props) {
    super(props);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeEmail = this.onChangeEmail.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    this.state = {
      email: "",
      password: "",
      loading: false,
      message: ""
     
    };
  }



  componentDidMount() {
    this.checkIfLoggedSession();
  }

  checkIfLoggedSession = () => {
  if(AuthService.getCurrentUser()) {
      if( localStorage.getItem("expTimeInMS") < (Date.now() / 1000)) {
      window.location.href = `/`;
      AuthService.logout();
      window.location.reload();
    }
  }
  }


  onChangeEmail(e) {
    this.setState({
      email: e.target.value
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value
    });
  }

  handleLogin(e) {
    e.preventDefault();

    this.setState({
      message: "",
      loading: true
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.login(this.state.email, this.state.password).then(
        () => {
          this.props.history.push("/");
          window.location.reload();
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          // Only show activation message when backend explicitly returns ACCOUNT_NOT_ACTIVATED
          // (never for bad credentials - security)
          const isAccountNotActivated =
            (typeof resMessage === "string" && resMessage === "ACCOUNT_NOT_ACTIVATED");

          this.setState({
            loading: false,
            message: isAccountNotActivated ? translate("check-ur-namil") : translate("user-pass-incorrect")
          });
        }
      );
    } else {
      this.setState({
        loading: false
      });
    }
  }


   // related to Login Forum -- END





  render() {


    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
    const handleLogout = () => {
      AuthService.logout();
      window.location = '/';
  }

  const goToProfile = () => {
    window.location = '/profile';
}
    
    const required = value => {
      if (!value) {
        return (

       
          <div className="alertDanger" >
               <p className="alertDanger">  
         {translate("mandatory")}         
          </p> 
          </div>
        );
      }
    };


const donationButton = (
<form action="https://www.paypal.com/donate" method="post" target="_top">
<input type="hidden" name="hosted_button_id" value="MVPTNW8DNTUNU" />
<input type="image" src="https://www.paypalobjects.com/en_US/i/btn/btn_donate_LG.gif" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" />
<img alt="" border="0" src="https://www.paypal.com/en_IL/i/scr/pixel.gif" width="1" height="1" />
</form>
);

    return (
      
      <div className="top-level-page-main home">
        <section className="top-container">
          <div className="home-showcase">
          <img  className="imgSectionMain" src={elikaMain} alt="main_bish_elika" />
          </div>
     
   <div className="top-box top-box-a">
     <div className="box-a-aligned">
            {loggedInUser ?
            <div className="loggedIn-home">
             <h2> {loggedInUser.email}   </h2>
             <h3>  {translate("welcome")}  </h3>
             <button className="btn-red" onClick={handleLogout}> {translate("logout")} </button>
             <button className="btn" onClick={goToProfile}> {translate("my-profile")} </button>
              {whatRole === 'USER' ? 
             <p className="alertDanger">{translate("request-permission-bish")}</p> : <p></p>  
            }
            
            </div> 
            : 
            <div className="notSignedIn-home">
       <Form
            onSubmit={this.handleLogin}
            ref={c => {
              this.form = c;
            }}
          >
            <div className="form-group-home">
              <Input
                type="text"
                className="form-control-home"
                name="email"
                value={this.state.email}
                onChange={this.onChangeEmail}
                validations={[required]}
              />
               <label htmlFor="email"> {translate("email")}  </label>
               
            </div>

            <div className="form-group-home">
              <Input
                type="password"
                className="form-control-home"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
              />
               <label htmlFor="password"> {translate("password")}    </label>
            </div>

            <div className="form-group-home">
            <div className="register">
          <a href="/register" className="btn">{translate("join-now")}</a>



          </div>
            <button
                className="btn"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
            {translate("login-now")} 
              </button>
            
            
            </div>

            {this.state.message && (
              <div className="form-group-home">
                <div className="alertDanger" role="alert">
                  {this.state.message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          
            </div> 
          }
      
      </div>    
        </div>
        <div className="top-box top-box-b">
<h1 className="box-b-text">{translate("site-under-development")}  </h1>
<h1 className="box-b-text"> {translate("welcoming-suggestions")} </h1>
<a href="/contact-us" className="btn">{translate("contact-us")}  </a>
<p className="donation-div">
   {donationButton}
   <h1>{translate("donation-text")}</h1>
   </p>



        </div>
        
      
      </section>



        <section className="boxes">
          <div className="box">
            <GiPartyPopper size={70} color="black" ></GiPartyPopper>
            <h2> {translate("activities")} </h2>
            <a href="/family-activities" className="btn">{translate("click-here")}  </a>
        </div>

          <div className="box">
            <AiOutlineNotification size={70} ></AiOutlineNotification>
            <h2> {translate("notifications")} </h2>
            <a href="/family-notification" className="btn">{translate("click-here")} </a>
        </div>

          <div className="box">
            <GiPineTree size={70} ></GiPineTree>
            <h2> {translate("familytree")} </h2>
            <a href="/family-tree-instruction" className="btn">{translate("click-here")} </a>
        </div>

          <div className="box">
            <BiPhotoAlbum size={70} ></BiPhotoAlbum>
            <h2>  {translate("gallery")}  </h2>
            <a href="/family-gallery" className="btn">{translate("click-here")} </a>
     
        </div>

        <div className="box">
            <GiChurch size={70} ></GiChurch>
            <h2>   {translate("historical-info")}    </h2>
            <a href="/family-history" className="btn">{translate("click-here")} </a>
     
        </div>

        <div className="box">
            <GiPublicSpeaker size={70} ></GiPublicSpeaker>
            <h2>    {translate("about-us")}   </h2>
            <a href="family-aboutus" className="btn">{translate("click-here")} </a>
     
        </div>

        </section>

        <section className="info">
      <img  className="imgSectionMAlol" src={sectionImg} alt="section1" />
<div className="sectionInfoMain">
  <h3>{translate("maaloul-village")}</h3> 

  <p dir='rtl' lang='ar'>{translate("maaloul-parag-first")}</p>
  <p dir='rtl' lang='ar'>{translate("maaloul-parag-second")}</p>
  
  <a href="/family-history" className="btn">{translate("read-more")}</a>
  </div>
        </section>

      </div>


    
    )
  }
}
